<template>
  <el-drawer
    :visible.sync="active"
    size="300px"
    class="apex-table-columns-filter"
    :title="t('table.toolbar.columnsSetup')"
    append-to-body
  >
    <div class="apex-drawer-wrapper">
      <!-- 全选 反选 -->
      <el-card shadow="never">
        <div class="component--list">
          <div key="__first__" class="component--list-item" style="padding: 10px">
            <span>
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="onCheckAllChange">
                {{ showLength }} / {{ options.length }}
              </el-checkbox>
            </span>
            <span class="title">{{ t('table.toolbar.fixedSort') }}</span>
          </div>
          <el-scrollbar wrap-class="scrollbar-wrapper">
            <draggable v-model="currentValue" ghost-class="ghost" handle=".handle" :animation="200">
              <transition-group>
                <div v-for="(option, index) of currentValue" :key="option.key" class="component--list-item">
                  <el-checkbox v-model="currentValue[index].show" :title="option.title" :disabled="option.disabled">
                    {{ option.title || option.key || "未命名" }}
                  </el-checkbox>
                  <div class="set-wrapper">
                    <apex-table-columns-fixed-controller
                      v-model="currentValue[index].fixed"
                      :disabled-fixed="disabledFixed"
                      @change="value => fixedChange(index, value)"
                    />
                    <div class="component--list-item-handle" :class="{ handle: !disabledSort, 'disabled-sort': disabledSort }">
                      <img src="../../img/drag.png" :title="t('table.toolbar.dragDropSort')">
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-scrollbar>
        </div>
      </el-card>
      <el-row class="drawer-footer" :gutter="10">
        <el-col :span="12">
          <el-button icon="el-icon-refresh" @click="reset">{{ t('table.toolbar.restore') }}</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-check" @click="submit()">{{ t('table.toolbar.confirm') }}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import locale from '@/mixins/index'
import draggable from 'vuedraggable'
import _clonedeep from 'lodash.clonedeep'
import apexTableColumnsFixedController from '../apex-table-columns-fixed-controller'
import TableStore from '../utils/storage'
// 输入 全部分表格列设置
// 输出 要显示的表格列 + 每列的设置

export default {
  name: 'ApexTableColumnsFilter',
  components: {
    draggable, apexTableColumnsFixedController
  },
  mixins: [locale],
  props: {
    options: {
      type: Array,
      default: () => [],
      required: false
    },
    value: {
      type: Array,
      default: () => [],
      required: false
    },
    storage: {
      type: [Boolean, String],
      default: true,
      required: false
    },
    storageNeedPrefix: {
      type: Boolean,
      default: true
    },
    disabledFixed: {
      type: Boolean,
      default: false
    },
    disabledSort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: [],
      active: false,
      checkAll: false
    }
  },
  computed: {
    // 显示的数量
    showLength() {
      return this.currentValue.filter(e => e.show).length
    },
    // 半选状态
    isIndeterminate() {
      const optionsLength = this.options.length
      const result = this.showLength > 0 && optionsLength !== this.showLength
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.checkAll = this.showLength > 0 && optionsLength === this.showLength
      return result
    }
  },
  watch: {
    options() {
      this.refresh()
    },
    value() {
      this.refresh()
    },
    active(value) {
      if (value === false) {
        this.refresh()
      }
    }
  },
  created() {
    const storedOptions = this.getOptionsFromStorage()
    this.storedOptions = storedOptions
    this.refresh()
    if (storedOptions) {
      this.submit() // 比较列设置后去同步提交 双向绑定
    }
  },
  methods: {
    // fixed 变化时触发
    fixedChange(index, value) {
      if (value) this.currentValue[index].show = true
      if (value === 'left') this.currentValue.unshift(this.currentValue.splice(index, 1)[0])
      if (value === 'right') this.currentValue.push(this.currentValue.splice(index, 1)[0])
    },
    // 全选和反选发生变化时触发
    onCheckAllChange(value) {
      this.currentValue = this.currentValue.map(item => {
        if (!item.disabled) {
          item.show = value
        }
        return item
      })
    },
    // 根据 value 和 options 计算 currentValue
    // 规则
    // currentValue.length === options.length
    // value.length <= options.length
    refresh() {
      const options = _clonedeep(this.options)
      const keyList = []
      const currentValue = []
      let checkAll = true
      // 设置比较源
      let compareSource = options
      if (this.storedOptions != null) {
        compareSource = this.storedOptions
      }
      // 计算
      compareSource.forEach(option => {
        // 在 value 尝试找到这个项目
        // 没有的话使用 option 中的默认值
        let storeItem = null
        if (this.storedOptions != null) {
          storeItem = option
        }
        let item = options.find(column => column.key === option.key)
        if (item) {
          keyList.push(item.key)
          let show = item != null && item.show !== false
          item = item || option

          if (storeItem) {
          // 使用本地保存的设置
            show = storeItem.show
            item.fixed = storeItem.fixed
            item.width = storeItem.width
          }
          item.show = show
          if (!show) {
            checkAll = false
          }
          currentValue.push(item)
        }
      })
      const newAddColumns = options.filter(option => !keyList.includes(option.key))
      newAddColumns.forEach(item => {
        item.show = false // #34094 新增列在Columns Setup里默认为不显示
        checkAll = false
        currentValue.push(item) // #34094 新增列在Columns Setup里放在最后
      })
      this.currentValue = currentValue
      this.checkAll = checkAll
    },
    // 开始选择
    start() {
      this.active = true
    },
    // 还原
    reset() {
      this.currentValue = _clonedeep(this.options)
      this.submit(true)
      this.clearThisStorage()
    },
    // 确认
    submit(noSave) {
      const result = []
      this.currentValue.forEach((item, index) => {
        result.push(item)
      })
      if (noSave !== true) {
        this.saveOptionsToStorage(result)
      }
      this.emit(result)
      this.active = false
    },
    emit(result) {
      this.$emit('input', result)
      this.$emit('change', result)
    },
    saveOptionsToStorage(value) {
      if (this.storage === false) {
        return
      }

      const storedOptions = []
      for (let i = 0; i < value.length; i++) {
        const item = value[i]
        const target = {
          key: item.key,
          show: item.show != null ? item.show : true,
          fixed: item.fixed,
          width: item.width
        }
        storedOptions.push(target)
      }
      this.storedOptions = storedOptions
      this.getStorageTable().updateTableValue(storedOptions)
    },
    getOptionsFromStorage() {
      if (this.storage === false) {
        return
      }
      return this.getStorageTable().getTableValue()
    },
    clearThisStorage() {
      this.getStorageTable().clearTableValue()
      this.storedOptions = null
    },
    getStorageTable() {
      if (this.StorageTableStore == null) {
        this.StorageTableStore = new TableStore({ $router: this.$route, tableName: 'columnsFilter', keyType: this.storage, storageNeedPrefix: this.storageNeedPrefix })
      }
      return this.StorageTableStore
    },
    getColumnsHash(columns) {
      const keys = []
      for (const item of columns) {
        keys.push(item.key)
      }
      keys.sort()
      let hash = ''
      for (const key of keys) {
        hash += key
      }
      return hash
    },
    // 列宽保存操作逻辑
    doResizable(newWidth, oldWidth, column) {
      const index = this.currentValue.findIndex(item => item.key === column.property)
      if (index > -1) {
        this.currentValue[index].width = newWidth
        this.submit()
      }
    }
  }
}
</script>

<style lang="scss">
.apex-table-columns-filter {
  :focus {
    outline: 0;
  }

  .scrollbar-wrapper {
    max-height: calc(100vh - 180px);
    padding-bottom: 4px;
  }

  .el-drawer__header {
    margin-bottom: 10px;
  }

  .apex-drawer-wrapper {
    padding: 10px;
  }

  .drawer-footer {
    padding: 20px;
    text-align: center;
    .el-button {
      padding: 12px 20px !important;
    }
  }

  .component--list {
    margin: -20px;

    .title {
      font-size: 14px;
    }
    .component--list-item {
      padding: 6px 10px;
      background-color: #fff;
      margin-bottom: 1px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.ghost {
        opacity: 0.8;
        background: #ecf5ff;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      .component--list-item-handle {
        padding: 0 6px;
        cursor: move;
        > img {
          width: 16px;
          height: 16px;
          transform: translateY(2px);
        }
        &.disabled {
          opacity: 0.3;
          cursor: pointer;
        }
        &.disabled-sort {
          cursor: not-allowed;
          i,
          img {
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }
      }
      .set-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .el-checkbox {
        display: flex;
        align-items: center;
        .el-checkbox__input {
          margin-top: 2px;
        }
        .el-checkbox__label {
          max-width: 150px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
